import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Box,
    Button,
    FluidImage,
    P,
} from '@vp/swan';
import { __, __image } from '@99designs/i18n';
import { usePricingProviderContext } from '@99designs/pricing';
import { CloudinaryImage } from '../CloudinaryImage';
import { HeaderPrice } from '../HeaderPrice';

interface PackagingDesignBannerProps {
    browseDesignServicesCtaOnClick: () => void;
    howItWorksCtaOnClick: () => void;
}

export function PackagingDesignBanner({
    browseDesignServicesCtaOnClick,
    howItWorksCtaOnClick,
}: PackagingDesignBannerProps) {
    const { lowestPrice, loading: priceLoading } = usePricingProviderContext();

    return (
        <Banner variant="card">
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow>{__('Design Services for Packaging')}</BannerEyebrow>
                    <BannerTitle as="h1">{__('Packaging, but make it iconic')}</BannerTitle>
                    <BannerDescription>
                        <P>
                            {__(
                                'Work with a professional designer to create custom packaging that turns every unboxing into an experience.'
                            )}
                        </P>
                    </BannerDescription>
                    <Box fontSkin="title-item">
                        <HeaderPrice price={lowestPrice} loading={priceLoading} />
                    </Box>
                    <BannerLinks>
                        <Button skin="primary" onClick={browseDesignServicesCtaOnClick}>
                            {__('Browse design services')}
                        </Button>
                        <Button skin="secondary" onClick={howItWorksCtaOnClick}>
                            {__('How it works')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <CloudinaryImage
                        render={(props) => (
                            <FluidImage
                                src={props.src}
                                srcSet={props.srcSet}
                                alt=""
                                role="presentation"
                                style={{ objectFit: 'contain' }}
                            />
                        )}
                        imagePath={__image(
                            'expert_services/DesignCategoryPage/Packaging/HeroBanner'
                        )}
                        width={800}
                    />
                </BannerImage>
            </BannerImageContainer>
        </Banner>
    );
}
